import React from 'react';
import { PhoneButton } from '../../components/PhoneButton/PhoneButton';

import './style.css';
import { Dozvon } from '../../components/Dozvon/Dozvon';

type CallViewLayout = 'active' | 'incoming' | 'outgoing' | 'incoming_accept_double';

interface CallViewProps {
    image: string;
    name: string;
    layout: CallViewLayout;

    onAccept?: VoidFunction;
    onHang?: VoidFunction;
}

interface IClickable {
    onClick?: VoidFunction;
}

const AcceptButton: React.FC<IClickable> = (props) => {
    return (
        <div className='call-button__container'>
            <div className='call-button__text'>Ответить</div>
            <PhoneButton type='accept' onClick={props.onClick} />
        </div>
    );
};

const HangButton: React.FC<IClickable> = (props) => {
    return (
        <div className='call-button__container'>
            <div className='call-button__text'>Сбросить</div>
            <PhoneButton type='hang' onClick={props.onClick} />
        </div>
    );
};

export const CallView: React.FC<CallViewProps> = ({ name, layout, image, onAccept, onHang }) => {
    const buttons: ('hang' | 'accept')[] = [];

    if (['outgoing', 'active'].includes(layout)) {
        buttons.push('hang');
    } else if (layout === 'incoming') {
        buttons.push('hang', 'accept');
    } else if (layout === 'incoming_accept_double') {
        buttons.push('accept', 'accept');
    }

    return (
        <div className='call__root'>
            <div className='call__top-block'>
                <img className='call__image' src={image} />
                <div className='call__name'>{name}</div>
            </div>
            {layout === 'outgoing' && (
                <div className='call__dozvon'>
                    <Dozvon />
                </div>
            )}
            <div className={buttons.length === 1 ? 'call__buttons-block single' : 'call__buttons-block'}>
                {buttons.map((button, index) => (
                    button === 'accept' ? (
                        <AcceptButton key={index} onClick={onAccept} />
                    ) : (
                        <HangButton key={index} onClick={onHang} />
                    )
                ))}
            </div>
        </div>
    );
};
